import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Header from "../../components/common/Header"
import Footer from "../../components/common/Footer"
import Profile from "../../components/User/MyPage/Profile"
import UserCard from "../../components/User/MyPage/UserCard"
import AdminCard from "../../components/User/MyPage/AdminCard"
import { useRecoilValue } from "recoil"
import { isLoggedInState } from "../../recoil/auth/atom"
import { useNavigate } from "react-router-dom"

const MyPage = () => {
  const [isAdmin] = useState(false)
  const isLoggedIn = useRecoilValue(isLoggedInState)
  const navigate = useNavigate()

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/")
    }
  }, [navigate, isLoggedIn])

  return (
    <>
      <Header />
      <Container>
        <Profile></Profile>
        <UserCard />
        {isAdmin ? <AdminCard></AdminCard> : <div></div>}
      </Container>
      <Footer />
    </>
  )
}

export default MyPage

const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
`
